import styled from 'styled-components/macro';

export const Container = styled.div`
  padding: 25px 25px 0px 25px;

  button.react-datepicker__close-icon {
    display: none;
  }
`;

export const SelectWrapper = styled.div`
  width: 240px;
  margin-bottom: 20px;
`;

export const InfoText = styled.div`
  font-size: 12px;
  color: #333;
  margin-bottom: 15px;
`;

export const ButtonsWrapper = styled.div`
  width: 240px;
  display: flex;
  justify-content: flex-end;
  & > * {
    margin-left: 10px;
  }
`;

export const Loader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 300px;
`;

export const Footer = styled.footer`
  bottom: 0;
  position: absolute;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 68px;
  min-height: 68px;
  background-color: #ecf0f1;
  padding: 0 20px;
`;

export const DatePickerStyled = styled.div`
  div.react-datepicker__month-text {
    height: 20px;
    color: #6c757d;
  }

  div.react-datepicker__header {
    height: 40px;
    text-align: center;
    padding-top: 5px;
    background: white;
  }

  div.react-datepicker__triangle {
    display: none;
  }

  div.react-datepicker__month-text {
    margin-top: 5px;
  }

  div.react-datepicker__month-text:hover,
  div.react-datepicker__month-text--keyboard-selected {
    background: #00aee0;
    color: white;
  }

  div.react-datepicker__month-wrapper:first-child {
    border-top: none;
  }

  div.react-datepicker__header {
    border-color: #e6eaef;
  }

  div.react-datepicker__month-wrapper {
    border-top: 1px solid #e6eaef;
    margin: 2px;
  }

  button.react-datepicker__navigation
    > span.react-datepicker__navigation-icon::after {
    color: black !important;
  }

  div.react-datepicker {
    border: none;
    box-shadow: 0px 5px 10px lightgray;
    width: 221px;
  }
`;
